module.exports = __webpack_public_path__ + "img/kort-30.917bcd5d.jpg";